import { defineComponent, h } from 'vue';
import { Timeout } from '@phi/util/timeout';
import { long_press_sensitivity } from '@phi/constants';
import { indicate_long_press } from '@phi/touch';
import { pointer_is_inside_element } from '@phi/util/dom';
import { do_nothing } from '@phi/util';

export const ClickableElement = defineComponent({
    props: {
        as: {
            required: false,
            type: String,
            default: 'div',
        },
        long: {
            required: false,
            type: Boolean,
            default: true,
        },
        long_press_sensitivity: {
            required: false,
            type: Number,
            default: long_press_sensitivity,
        },
    },

    emits: {
        click: (e: PointerEvent) => true,
        longClick: (e: PointerEvent) => true,
        enter: (e: PointerEvent) => true,
        leave: (e: PointerEvent) => true,
    },

    data() {
        return {
            is_long_press: false,
            timeout: new Timeout(this.on_timeout as VoidFunction, this.long_press_sensitivity),
        };
    },

    methods: {
        on_timeout() {
            indicate_long_press();
            this.is_long_press = true;
        },

        reset() {
            this.is_long_press = false;
            this.timeout.stop();
        },

        pointer_over(e: PointerEvent) {
            this.reset();
            this.$emit('enter', e);
            if (e.pointerType !== 'mouse')
                this.timeout.start();
        },

        pointer_leave(e: PointerEvent) {
            this.reset();
            this.$emit('leave', e);
        },

        pointer_up(e: PointerEvent) {
            if (!(
                this.$el instanceof HTMLElement
                && pointer_is_inside_element(this.$el, e)
            ))
                do_nothing();
            else if (this.is_long_press && this.long)
                requestAnimationFrame(() => this.$emit('longClick', e));
            else
                requestAnimationFrame(() => this.$emit('click', e));
            this.reset();
        },
    },

    render() {
        return h(this.as, {
            onPointerup: this.pointer_up,
            onPointerover: this.pointer_over,
            onPointerleave: this.pointer_leave,
        }, this.$slots.default && this.$slots.default());
    }
});
